module.exports = __webpack_public_path__ + "static/img/zhenyu.d7cad0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/zhenyu.png
// module id = 6MdI
// module chunks = 1